<template>
  <div>
    <el-group-title class="d_jump" index="pcConcMatProtocol">
      <template slot="groupTitle">
        <!-- :rules="rules" -->
        <el-form
          :model="form"
          ref="form"
          label-width="163px"
          class="ccui-form demo-form-inline"
          :inline="true"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目名称：" prop="name">
                <el-input
                  v-model="form.name"
                  class="ccui-form-longInput"
                  maxlength="200"
                  placeholder="请输入项目名称"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="合同编码：" prop="code">
                <el-input
                  v-model.trim="form.code"
                  disabled
                  class="ccui-form-longInput"
                  placeholder="请输入原合同编码"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </el-group-title>
  </div>
</template>

<script>
// import { getTaxRateDict } from "../../api/item-list";
export default {
  name: "pcConcMatProtocol.vue",
  props: {
    dataInfo: {
      type: Object
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      form: {
        code: "",
        id: null,
        name: ""
      },
      taxRateList: [], //税率表
      typeDictList: [], //发票类型字典数据
      contractStatus: "", //审批流程状态
      isTrue: false
    };
  },
  watch: {
    dataInfo(item) {
      console.log(item);
      this.form = item;
    }
  },
  created() {
    // let timestamp = Date.parse(new Date());
    // this.form.code = timestamp;
  },
  methods: {
    // 金额四舍五入
    contractInfo() {
      // getTaxRateDict({}).then(res => {
      //   this.taxRateList = res.data.data;
      // });
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
/deep/.ccui-form {
  margin-top: 0;
}
/deep/.group-content {
  margin-top: 0;
}
/deep/.el-form--inline .el-form-item__label {
  width: 170px !important;
}
/deep/.el-table {
  .el-table__body {
    height: 36px;
  }
}
/deep/.el-col-13 {
  width: 100%;
}
/deep/.el-col-13 .el-form-item__content {
  min-width: 570px;
  max-width: 65%;
}
/deep/.ccui-form-textArea {
  width: 100%;
  .el-textarea {
    width: 760px;
  }
}
/deep/.el-col-12 {
  // margin-right: 68px;
  width: 432px;
  height: 100%;
}
/deep/.el-col-12 .el-form-item__content {
  width: 195px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 260px;
}
/deep/.ccui-form .ccui-form-textArea,
.ccui-form .ccui-form-textArea .el-textarea {
  min-height: 31px;
}
.content {
  width: 700px;
}
/deep/ .el-col-13 .el-none > .el-form-item__content {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
/deep/.el-form--inline .el-form-item__label {
  float: left;
}
</style>
